import { PropsWithChildren } from 'react';

import { Typography } from '@/components/ui/Typography/Typography.styles';

import { ButtonBox } from './Button.styles';
import { ButtonProps } from './Button.type';

export const Button: React.FC<PropsWithChildren<ButtonProps>> = ({
  children,
  type,
  variant = 'primary',
  size = 'l',
  isLoading,
  fullWidth = false,
  startIcon,
  typography = 'title4',
  tag = 'button',
  className,
  ...props
}) => {
  const buttonSpecificProps =
    tag === 'button'
      ? {
          type: type ?? 'button'
        }
      : {};

  return (
    <ButtonBox
      {...props}
      {...buttonSpecificProps}
      as={tag as string}
      className={className}
      $size={size}
      $isLoading={isLoading}
      $variant={variant}
      $fullWidth={fullWidth}
      $isIcon={!!startIcon && !children}
    >
      {startIcon}
      {children && <Typography variant={typography}>{children}</Typography>}
    </ButtonBox>
  );
};
